// Saved Cards
export const UPDATE_SAVED_CARDS = "update_saved_cards";
export const SET_UPDATE_SAVED_CARDS_LOADING = "set_update_saved_cards_loading";
export const SAGA_FETCH_SAVED_CARDS = "saga_fetch_saved_cards";

// Saved Comparisons
export const UPDATE_SAVED_COMPARISONS = "update_saved_comparisons";
export const SET_UPDATE_SAVED_COMPARISONS_LOADING = "set_update_saved_comparisons_loading";
export const SAGA_FETCH_SAVED_COMPARISONS = "saga_fetch_saved_comparisons";


//Reviews
export const GET_REVIEWS = "GET_REVIEWS";
export const GET_AUTO_SUGGESTIONS = "GET_AUTO_SUGGESTIONS";
export const SUBMIT_REVIEW = "SUBMIT_REVIEW";
export const SELECT_SUGGESTION = "SELECT_SUGGESTION"


export const  GET_FillExamcodes = "GET_FillExamcodes";

export const  Get_ScrutinyDetails = "Get_ScrutinyDetails";

export const Get_Address='Get_Address';

export const  GET_FillProgramId = "GET_FillProgramId";
export const  GET_FillExamType = "GET_FillExamType";
export const  GET_FillSemesters = "GET_FillSemesters";
export const  GET_FillMonthYr = "GET_FillMonthYr";
export const  GET_FillBundleNo = "GET_FillBundleNo";
export const  GET_scruFillValType = "GET_scruFillValType";
export const GET_AdminFillProgramId="GET_AdminFillProgramId";
export const GET_AdmiDetails="GET_AdmiDetails";
export const GET_FillAdminExamType="GET_FillAdminExamType";
export const GET_FillAdminSem="GET_FillAdminSem";
export const GET_FillAdminmonthyr="GET_FillAdminmonthyr";
export const GET_FillAdminExamcodes="GET_FillAdminExamcodes";
export const GET_FillAdminBundleNo="GET_FillAdminBundleNo";
export const  GET_BundleKey = "GET_BundleKey";
 export const GET_AdminOmrCodes="GET_AdminOmrCodes";
export const GET_AdminMarksTable="GET_AdminMarksTable";
export const  GET_OmrCodes = "GET_OmrCodes";
export const  GET_MarksTable = "GET_MarksTable";

export const  GET_MarksSaving = "GET_MarksSaving";

export const  GET_CheckTotal = "GET_CheckTotal";


export const  GET_ScriptPath = "GET_ScriptPath";


export const GET_TokenUserRegister='GET_TokenUserRegister';


export const UPDATE_MARKS_TABLE = 'UPDATE_MARKS_TABLE';
export const UPDATE1_MARKS_TABLE='UPDATE1_MARKS_TABLE';

export const GET_CrystalPdf='GET_CrystalPdf';

export const GET_IpAddress='GET_IpAddress';

export const GET_Scrutinyapprove='GET_Scrutinyapprove';
export const GET_ScrutinyFeedback='GET_ScrutinyFeedback';

export const GET_AutoMarksSaving='GET_AutoMarksSaving';
export const  Get_Bundlestatus='Get_Bundlestatus';
export const Get_AdminBundlestatus='Get_AdminBundlestatus';
export const GET_AdminFillValType='GET_AdminFillValType';
export const GET_AdminTokenUserRegister='GET_AdminTokenUserRegister'